import React from 'react';
import { Switch, SwitchProps, styled, Box, alpha } from '@mui/material';
import { theme } from '../../../theme/ThemeProviderWithTheme';

interface IconSwitchProps extends SwitchProps {
  iconOn?: React.ReactNode;
  iconOff?: React.ReactNode;
}

const StyledSwitch = styled(Switch)<IconSwitchProps>(({ theme }) => ({
  width: 52,
  height: 34,
  padding: 7,
  '&.Mui-disabled .MuiSwitch-track': {
    opacity: 0.6,
    backgroundColor: theme.palette.grey[300],
  },
  '&.Mui-disabled .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.grey[300],
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
  },
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4,
    transitionDuration: '300ms',
    '&.Mui-disabled+.MuiSwitch-track': {
      opacity: 0.6,
      backgroundColor: theme.palette.grey[400],
    },

    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.common.white,
      },
    },
  },

  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.grey[400],
    width: 26,
    height: 26,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },

  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
  },
}));
export default function IconSwitch(props: IconSwitchProps) {
  const { iconOn, iconOff, checked, disabled, ...rest } = props;

  return (
    <StyledSwitch
      checked={checked}
      disabled={disabled}
      checkedIcon={
        <StyledIconBox
          sx={{
            '& svg': {
              color: disabled
                ? theme.palette.grey[500]
                : theme.palette.primary.main,
            },
          }}
          disabled={disabled}
        >
          {iconOn}
        </StyledIconBox>
      }
      icon={
        <StyledIconBox
          sx={{
            '& svg': {
              color: disabled
                ? theme.palette.grey[500]
                : theme.palette.primary.main,
            },
          }}
          disabled={disabled}
        >
          {iconOff}
        </StyledIconBox>
      }
      {...rest}
    />
  );
}

const StyledIconBox = styled(Box)<{
  disabled?: boolean;
}>(({ disabled }) => ({
  backgroundColor: disabled
    ? theme.palette.grey[200]
    : theme.palette.common.white,
  borderRadius: '100%',
  boxShadow: `-2px 2px 4px ${alpha(theme.palette.common.black, 0.2)}`,
  display: 'flex',
  padding: '6px',
  width: '25px',
  height: '25px',
  '& svg': {
    width: '100%',
    height: '100%',
    color: theme.palette.grey[500],
  },
}));
